// extracted by mini-css-extract-plugin
export default {"checkbox":"SelectAllCheckbox_checkbox__N0KHQ"};